import { render } from "./CreancesAssurance.vue?vue&type=template&id=69598238&scoped=true"
import script from "./CreancesAssurance.vue?vue&type=script&lang=js"
export * from "./CreancesAssurance.vue?vue&type=script&lang=js"

import "./CreancesAssurance.vue?vue&type=style&index=0&id=69598238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69598238"]])

export default __exports__